import React from "react";
import Quotes from "../Pictos/Quotes";

import styles from "./Quote.module.scss";

export default function Quote({text, source}) {
    return (
        <div className={styles.Main}>
            <Quotes/>

            <p className={styles.Text} dangerouslySetInnerHTML={{__html: text}}/>

            {
                source ? <p className={styles.Source} dangerouslySetInnerHTML={{__html: source}}/> : null
            }
        </div>
    )
}
